// extracted by mini-css-extract-plugin
export var animationContainer = "_oi-0";
export var footer = "_oi-1";
export var gray = "_oi-2";
export var lineItem = "_oi-3";
export var lineItemImage = "_oi-4";
export var lineItemInfo = "_oi-5";
export var lineItemText = "_oi-6";
export var lineItems = "_oi-7";
export var modalContent = "_oi-8";
export var options = "_oi-9";
export var orderName = "_oi-a";
export var refundAmount = "_oi-b";